/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Per-tab integer counters rendered above the thread list.
 */
export interface TabCounts {
  /** @minimum 0 */
  inbox: number;
  /** @minimum 0 */
  sent: number;
  /** @minimum 0 */
  cancelled: number;
  /** @minimum 0 */
  scheduled: number;
  /** @minimum 0 */
  interested: number;
  /** @minimum 0 */
  not_interested: number;
}
